import { Badge } from "@/components/ui/badge";
import { DELIVERABLE_META, PAYMENT_META, DELIVERABLE_STATUS_META } from "@/lib/constants";

export function DeliverableBadge({ type }) {
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${DELIVERABLE_META[type] || DELIVERABLE_META.Other}`}
      data-testid={`deliverable-badge-${type}`}
    >
      {type}
    </span>
  );
}

export function PaymentBadge({ status }) {
  const label = { PAID: "Paid", PARTIALLY_PAID: "Partial", UNPAID: "Unpaid" }[status] || status;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${PAYMENT_META[status] || PAYMENT_META.UNPAID}`}>
      {label}
    </span>
  );
}

export function DeliverableStatusBadge({ status }) {
  const meta = DELIVERABLE_STATUS_META[status] || DELIVERABLE_STATUS_META.NEW;
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium ${meta.chip}`}>
      {meta.label}
    </span>
  );
}
